import { useQuery, useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig, QueryConfig } from '@/lib/react-query';

import { AppointmentResponse, Event ,OnBoardingResponse} from '../types';
export const getOnBoardingDetails = ({stepId }: UseBusinessOptions): Promise<AppointmentResponse> => {
  return axios.get(`/onboarding/progress/get`);
};

type UseBusinessOptions = {
    stepId?: number;

  };

type UseOnBoardingDetailsOptions = {
  config?: MutationConfig<typeof getOnBoardingDetails>;
};

export const useOnBoardingDetails = ({ config }: UseOnBoardingDetailsOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getOnBoardingDetails,
  });
};

export const getUpdateOnBoardingDetails = ({stepId }: UseBusinessOptions): Promise<OnBoardingResponse> => {
    return axios.get(`/onboarding/progress/set/${stepId}`);
  };
  
  type useUpdateOnBoardingDetails = {
    config?: MutationConfig<typeof getUpdateOnBoardingDetails>;
  };
  
  export const useUpdateOnBoardingDetails = ({ config }: useUpdateOnBoardingDetails = {}) => {
    return useMutation({
      ...config,
      mutationFn: getUpdateOnBoardingDetails,
    });
  };
  
